import { isBrowser, makeUuid } from '@knapsack/utils';
import { knapsackGlobal } from '@/global';
import { ksHttpHeaders } from '@knapsack/core';
import { extractPossibleInstanceIdFromSite } from '@/core/env-and-content-src/utils';
import { getAccessTokenFromMem } from '@/domains/users/auth/client';

function getSiteIdAndInstanceId() {
  // given `/site/toby/abc123`
  // theWordSite is 'site'
  // siteId is 'toby'
  // instanceId is 'abc123'
  const [, theWordSite, siteId, instanceId] =
    window.location.pathname.split('/');
  if (theWordSite === 'setup' && siteId) {
    return {
      siteId,
    };
  }
  if (
    // in the `/site/*` path
    theWordSite === 'site' &&
    // not in the `/site/custom` path - which is local dev and therefore we cannot rely on url for getting info - we'll use Xstate context below instead
    siteId !== 'custom' &&
    // have a siteId
    siteId &&
    // have an instanceId
    instanceId
  ) {
    // ok, then we can use the info in url to reliably get siteId and instanceId
    return { siteId, instanceId };
  }
  // otherwise, we'll use Xstate context
  const { site } = knapsackGlobal.appService.getSnapshot().context;
  return {
    siteId: site?.meta.siteId,
    instanceId: extractPossibleInstanceIdFromSite(site),
  };
}

export async function getHttpHeaders({
  hasuraClientName,
}: {
  hasuraClientName?: string;
} = {}): Promise<Record<string, string>> {
  if (!isBrowser) {
    // Avoid throwing in e.g. Storybook, just return empty headers
    return {};
  }
  const { siteId, instanceId } = getSiteIdAndInstanceId();
  const headers: Record<string, string> = {
    [ksHttpHeaders.siteId]: siteId,
    [ksHttpHeaders.requestId]: makeUuid(),
    [ksHttpHeaders.authEnv]: process.env.NEXT_PUBLIC_AUTH_ENV,
  };
  if (hasuraClientName) {
    headers['Hasura-Client-Name'] = hasuraClientName;
  }
  if (instanceId) {
    headers[ksHttpHeaders.instanceId] = instanceId;
  }
  try {
    const accessToken = getAccessTokenFromMem();
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }
  } catch (e) {
    console.error('getHttpHeaders() error', e);
  }
  return headers;
}
